import React from 'react';
import Banner from '@cpg-its/ads.containers.banner';
import { useSelector } from 'react-redux';
import { FormikProps } from 'formik';
import { FormField } from '../../../global/components/form-element/form-field';
import { TcsmStates } from '../../../root/tcsm-model';
import { parseLov } from '../../../global/helpers/form-data-helper';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { esGenderOptions, GenderOptions, YesNoOptions } from '../../../global/constants/lists';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { FormGroup } from '../../../global/components/layout/form-group';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { DividerSection } from '../../../global/components/layout/divider-section';

interface Props {
	id: string;
	arrayField: string;
	formikProps: FormikProps<any>;
	settings: ClergyBioSettings;
	showDom?: boolean;
	showStepChild?: boolean;
	disabled?: boolean;
	setList?: any;
	removable?: boolean;
	showLastNameAtBirth?: boolean;
	showClergy?: boolean;
	errors?: any
	showID?: boolean;
	hideDivider?: boolean;
}

function ClergyBioRelationshipPersonFields(props: Props) {

	const { formikProps, id, settings, disabled, arrayField, showDom, showStepChild, setList, showClergy, showLastNameAtBirth, removable, errors, showID, hideDivider } = props;
	const buttonClasses = buttonStyles();	
	const language = useSelector<TcsmStates, string>(state => state.globalization?.currentlanguage);
	const suffix = useSelector<TcsmStates, any>(state => state.lovProcState?.personLov?.suffix);
	const mappedSuffix = suffix ? parseLov(suffix) : [];
	const remove = () => {
		const list = formikProps?.values[arrayField];
		list.splice(Number(id), 1);
		setList({ ...formikProps?.values, child_relations_attributes: list });
	};	

	const mappedError = errors?.length >= 0 ? errors[Number(id)] : null;

	return (
		<DividerSection dashedBorder={!hideDivider} removeDivider={hideDivider}>
			{showID && <ContentSpacer><h3>{settings?.childCountText} {Number(id) + 1}</h3></ContentSpacer>}
			<FormGroup>
				{
					mappedError?.blockError &&
					<ContentSpacer>
						<div data-formdata={`${arrayField}.${id}.blockError`} ></div>
						<Banner
							banner={{
								type: 'error',
								label: <p><strong>{mappedError?.blockError}</strong></p>,
							}}
						/>
					</ContentSpacer>
				}

				<div className='form-item'>
					<FormField
						name={`${arrayField}.${id}.firstName`}
						label={settings?.legalFirstNameLabel}
						component='input'
						touched={formikProps.touched}
						errors={formikProps.errors}
						required
						disabled={disabled}
						published={showClergy}
					/>					
				</div>

				<div className='form-item'>
					<FormField
						name={`${arrayField}.${id}.middleName`}
						label={settings?.legalMiddleNameLabel}
						component='input'
						touched={formikProps.touched}
						errors={formikProps.errors}
						disabled={disabled}

					/>					
				</div>

				<div className='form-item'>
					<FormField
						name={`${arrayField}.${id}.lastName`}
						label={settings?.legalLastNameLabel}
						component='input'
						touched={formikProps.touched}
						errors={formikProps.errors}
						required
						disabled={disabled}
						published={showClergy}
					/>					
				</div>

				{
					showLastNameAtBirth &&
					<div className='form-item'>
						<FormField
							name={`${arrayField}.${id}.lastNameAtBirth`}
							label={settings?.lastNameAtBirthLabel}
							component='input'
							touched={formikProps.touched}
							errors={formikProps.errors}
							required
							disabled={disabled}
							/>
					</div>
				}

				<div className='form-item'>
					<FormField
						name={`${arrayField}.${id}.suffix`}
						label={settings?.suffixLabel}
						component='input'
						options={mappedSuffix}
						errors={formikProps.errors}
						select
						disabled={disabled}
						touched={formikProps.touched}
					/>					
				</div>

				<div className='form-item'>
					<FormField
						name={`${arrayField}.${id}.gender`}
						label={settings?.genderLabel}
						component='radioGroup'
						options={language === 'en' ? GenderOptions : esGenderOptions}
						touched={formikProps.touched}
						errors={formikProps.errors}
						required
						disabled={disabled}
					/>						
				</div>

				<div className='form-item'>
					<FormField
						name={`${arrayField}.${id}.dob`}
						label={settings?.dateOfBirthLabel}
						component='datePicker'
						touched={formikProps.touched}
						errors={formikProps.errors}
						required
						autoWidth
						disabled={disabled}
						/>							
				</div>
				{
					showDom &&
					<div className='form-item'>
						<FormField
							name={`${arrayField}.${id}.dom`}
							label={settings?.dateOfMarriageLabel}
							component='datePicker'
							touched={formikProps.touched}
							errors={formikProps.errors}
							autoWidth
							disabled={disabled}
						/>						
					</div>
				}
				{
					showStepChild &&
					<div className='form-item'>
						<FormField
							name={`${arrayField}.${id}.stepchild`}
							label={settings?.stepChildLabel}
							component='radioGroup'
							options={YesNoOptions}
							touched={formikProps.touched}
							errors={formikProps.errors}
							disabled={disabled}
						/>						
					</div>
				}
				{
					removable && <div className='form-item'><button className={buttonClasses.linkButton} type='button' onClick={() => remove()} >{settings?.removeChildButtonText}</button></div>
				}
			</FormGroup>
		</DividerSection>

	);
}

ClergyBioRelationshipPersonFields.defaultProps = {
	showDom: false,
	showStepChild: false,
	disabled: false,
	setList: null,
	removable: false,
	showLastNameAtBirth: false,
	errors: null,
	showClergy: false,
	showID: false,
	hideDivider: false,
};

export default ClergyBioRelationshipPersonFields;